export const getStatusColor = (status) => {
    // If status is undefined, treat it as completed
    if (!status) return 'active';

    switch (status) {
      case 'approved': return 'active';
      case 'rejected': return 'error';
      case 'pending': return 'warning';
      case 'verified': return 'active';
      case 'completed': return 'active';
      default: return 'default';
    }
  };

export const getVisibleFields = (fields, formValues) => {
  return fields.filter(field => {
    if (!field.parent_key) return true;
    const parentVal = formValues[field.parent_key];
    return field.parent_value?.includes(parentVal);
  });
};

export const convertFieldName = (fieldName = "") => {
  return String(fieldName)
    .replaceAll("_", " ")
    .replace(/\w\S*/g, (txt) =>
      txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    );
};



